// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.mosaic.mosaic-blueprint-theme {
  background: #A7B6C2;
}

.mosaic.mosaic-blueprint-theme .mosaic-zero-state {
  background: #E1E8ED;
  border-radius: 3px;
  box-shadow: none;
}

.mosaic.mosaic-blueprint-theme .mosaic-zero-state .default-zero-state-icon {
  font-size: 120px;
}

.mosaic.mosaic-blueprint-theme .mosaic-split:hover {
  background: none;
}

.mosaic.mosaic-blueprint-theme .mosaic-split:hover .mosaic-split-line {
  box-shadow: 0 0 0 1px #2B95D6;
}

.mosaic.mosaic-blueprint-theme .mosaic-drop-target .drop-target-container .drop-target,
.mosaic.mosaic-blueprint-theme.mosaic-drop-target .drop-target-container .drop-target {
  background: rgba(72, 175, 240, 0.2);
  border: 2px solid #2B95D6;
  transition: opacity 100ms;
  border-radius: 3px;
}

.mosaic.mosaic-blueprint-theme .mosaic-window,
.mosaic.mosaic-blueprint-theme .mosaic-preview {
  box-shadow: none;
  border-radius: 3px;
}

.mosaic.mosaic-blueprint-theme .mosaic-window-toolbar {
  box-shadow: 0 1px 1px rgba(16, 22, 26, 0.15);
  border-top-right-radius: 3px;
  border-top-left-radius: 3px;
}

.mosaic.mosaic-blueprint-theme .mosaic-window-toolbar.draggable:hover .mosaic-window-title {
  color: #10161A;
}

.mosaic.mosaic-blueprint-theme .mosaic-window-toolbar.draggable:hover {
  background: linear-gradient(to bottom, #FFFFFF, #F5F8FA);
}

.mosaic.mosaic-blueprint-theme .mosaic-window-title {
  font-weight: 600;
  color: #394B59;
}

.mosaic.mosaic-blueprint-theme .mosaic-window-controls .separator {
  border-left: 1px solid #D8E1E8;
}

.mosaic.mosaic-blueprint-theme .mosaic-window-controls .bp3-button,
.mosaic.mosaic-blueprint-theme .mosaic-window-controls .bp3-button:before {
  color: #738694;
}

.mosaic.mosaic-blueprint-theme .default-preview-icon {
  font-size: 72px;
}

.mosaic.mosaic-blueprint-theme .mosaic-window-body {
  border-top-width: 0;
  background: #F5F8FA;
  border-bottom-right-radius: 3px;
  border-bottom-left-radius: 3px;
}

.mosaic.mosaic-blueprint-theme .mosaic-window-additional-actions-bar {
  transition: height 250ms;
  box-shadow: 0 1px 1px rgba(16, 22, 26, 0.15);
}

.mosaic.mosaic-blueprint-theme .mosaic-window-additional-actions-bar .bp3-button,
.mosaic.mosaic-blueprint-theme .mosaic-window-additional-actions-bar .bp3-button:before {
  color: #738694;
}

.mosaic.mosaic-blueprint-theme.additional-controls-open .mosaic-window-toolbar {
  box-shadow: none;
}

.mosaic.mosaic-blueprint-theme .mosaic-preview {
  border: 1px solid #8A9BA8;
}

.mosaic.mosaic-blueprint-theme .mosaic-preview h4 {
  color: #394B59;
}

.mosaic.mosaic-blueprint-theme.bp3-dark {
  background: #202B33;
}

.mosaic.mosaic-blueprint-theme.bp3-dark .mosaic-zero-state {
  background: #30404D;
  box-shadow: none;
}

.mosaic.mosaic-blueprint-theme.bp3-dark .mosaic-split:hover .mosaic-split-line {
  box-shadow: 0 0 0 1px #137CBD;
}

.mosaic.mosaic-blueprint-theme.bp3-dark .mosaic-drop-target .drop-target-container .drop-target,
.mosaic.mosaic-blueprint-theme.bp3-dark.mosaic-drop-target .drop-target-container .drop-target {
  background: rgba(16, 107, 163, 0.2);
  border-color: #137CBD;
}

.mosaic.mosaic-blueprint-theme.bp3-dark .mosaic-window-toolbar,
.mosaic.mosaic-blueprint-theme.bp3-dark .mosaic-window-additional-actions-bar {
  background: #30404D;
  box-shadow: 0 1px 1px rgba(16, 22, 26, 0.4);
}

.mosaic.mosaic-blueprint-theme.bp3-dark .mosaic-window,
.mosaic.mosaic-blueprint-theme.bp3-dark .mosaic-preview {
  box-shadow: none;
}

.mosaic.mosaic-blueprint-theme.bp3-dark .mosaic-window-toolbar.draggable:hover .mosaic-window-title {
  color: #FFFFFF;
}

.mosaic.mosaic-blueprint-theme.bp3-dark .mosaic-window-toolbar.draggable:hover {
  background: linear-gradient(to bottom, #394B59, #30404D);
}

.mosaic.mosaic-blueprint-theme.bp3-dark .mosaic-window .mosaic-window-toolbar,
.mosaic.mosaic-blueprint-theme.bp3-dark .mosaic-preview .mosaic-window-toolbar {
    box-shadow: 0 1px 1px rgb(0 0 0) !important;
    border-top-right-radius: 2px;
    border-top-left-radius: 2px;
    background: #2f343c !important;
    z-index: 4;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-shrink: 0;
    height: 30px;
}

.mosaic.mosaic-blueprint-theme.bp3-dark .mosaic-window .mosaic-window-title,
.mosaic.mosaic-blueprint-theme.bp3-dark .mosaic-preview .mosaic-window-title {
    font-weight: 600;
    color: #ffffff !important;
}

.mosaic.mosaic-blueprint-theme.bp3-dark .mosaic-window-title {
  color: #D8E1E8;
}

.mosaic.mosaic-blueprint-theme.bp3-dark .mosaic-window-controls .separator {
  border-color: #5C7080;
}

.mosaic.mosaic-blueprint-theme.bp3-dark .mosaic-window-controls .bp3-button,
.mosaic.mosaic-blueprint-theme.bp3-dark .mosaic-window-controls .bp3-button:before {
  color: #A7B6C2;
}

.mosaic.mosaic-blueprint-theme.bp3-dark .mosaic-window-body {
  background: #293742;
}

.mosaic.mosaic-blueprint-theme.bp3-dark .mosaic-window-additional-actions-bar .bp3-button,
.mosaic.mosaic-blueprint-theme.bp3-dark .mosaic-window-additional-actions-bar .bp3-button:before {
  color: #BFCCD6;
}

.mosaic.mosaic-blueprint-theme.bp3-dark.additional-controls-open .mosaic-window-toolbar {
  box-shadow: none;
}

.mosaic.mosaic-blueprint-theme.bp3-dark .mosaic-preview {
  border-color: #5C7080;
}

.mosaic.mosaic-blueprint-theme.bp3-dark .mosaic-preview h4 {
  color: #EBF1F5;
}

.mobile-friendly-navbar {
    padding: 10px;
}

.responsive-navbar-group {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 10px;
}

.responsive-heading {
    font-size: 18px;
    white-space: nowrap;
}

.responsive-divider {
    display: none;
}

.navbar-controls {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    align-items: center;
}

.responsive-select {
    min-width: 120px;
}

.responsive-button {
    white-space: nowrap;
}

@media (max-width: 768px) {
    .responsive-heading {
        font-size: 16px;
    }

    .responsive-button {
        padding: 5px 10px;
        font-size: 12px;
    }
}

@media (max-width: 480px) {
    .responsive-navbar-group {
        flex-direction: column;
        align-items: flex-start;
    }

    .navbar-controls {
        width: 100%;
        justify-content: space-between;
    }

    .responsive-select {
        width: 100%;
    }

    .responsive-button {
        flex: 1;
        text-align: center;
    }
}`, "",{"version":3,"sources":["webpack://./src/lib/components/assets/style.css"],"names":[],"mappings":";AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;EAEE,mCAAmC;EACnC,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,4CAA4C;EAC5C,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA;EACE,wBAAwB;EACxB,4CAA4C;AAC9C;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;EAEE,mCAAmC;EACnC,qBAAqB;AACvB;;AAEA;;EAEE,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;;IAEI,2CAA2C;IAC3C,4BAA4B;IAC5B,2BAA2B;IAC3B,8BAA8B;IAC9B,UAAU;IACV,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,cAAc;IACd,YAAY;AAChB;;AAEA;;IAEI,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,sBAAsB;QACtB,uBAAuB;IAC3B;;IAEA;QACI,WAAW;QACX,8BAA8B;IAClC;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,OAAO;QACP,kBAAkB;IACtB;AACJ","sourcesContent":["\n.mosaic.mosaic-blueprint-theme {\n  background: #A7B6C2;\n}\n\n.mosaic.mosaic-blueprint-theme .mosaic-zero-state {\n  background: #E1E8ED;\n  border-radius: 3px;\n  box-shadow: none;\n}\n\n.mosaic.mosaic-blueprint-theme .mosaic-zero-state .default-zero-state-icon {\n  font-size: 120px;\n}\n\n.mosaic.mosaic-blueprint-theme .mosaic-split:hover {\n  background: none;\n}\n\n.mosaic.mosaic-blueprint-theme .mosaic-split:hover .mosaic-split-line {\n  box-shadow: 0 0 0 1px #2B95D6;\n}\n\n.mosaic.mosaic-blueprint-theme .mosaic-drop-target .drop-target-container .drop-target,\n.mosaic.mosaic-blueprint-theme.mosaic-drop-target .drop-target-container .drop-target {\n  background: rgba(72, 175, 240, 0.2);\n  border: 2px solid #2B95D6;\n  transition: opacity 100ms;\n  border-radius: 3px;\n}\n\n.mosaic.mosaic-blueprint-theme .mosaic-window,\n.mosaic.mosaic-blueprint-theme .mosaic-preview {\n  box-shadow: none;\n  border-radius: 3px;\n}\n\n.mosaic.mosaic-blueprint-theme .mosaic-window-toolbar {\n  box-shadow: 0 1px 1px rgba(16, 22, 26, 0.15);\n  border-top-right-radius: 3px;\n  border-top-left-radius: 3px;\n}\n\n.mosaic.mosaic-blueprint-theme .mosaic-window-toolbar.draggable:hover .mosaic-window-title {\n  color: #10161A;\n}\n\n.mosaic.mosaic-blueprint-theme .mosaic-window-toolbar.draggable:hover {\n  background: linear-gradient(to bottom, #FFFFFF, #F5F8FA);\n}\n\n.mosaic.mosaic-blueprint-theme .mosaic-window-title {\n  font-weight: 600;\n  color: #394B59;\n}\n\n.mosaic.mosaic-blueprint-theme .mosaic-window-controls .separator {\n  border-left: 1px solid #D8E1E8;\n}\n\n.mosaic.mosaic-blueprint-theme .mosaic-window-controls .bp3-button,\n.mosaic.mosaic-blueprint-theme .mosaic-window-controls .bp3-button:before {\n  color: #738694;\n}\n\n.mosaic.mosaic-blueprint-theme .default-preview-icon {\n  font-size: 72px;\n}\n\n.mosaic.mosaic-blueprint-theme .mosaic-window-body {\n  border-top-width: 0;\n  background: #F5F8FA;\n  border-bottom-right-radius: 3px;\n  border-bottom-left-radius: 3px;\n}\n\n.mosaic.mosaic-blueprint-theme .mosaic-window-additional-actions-bar {\n  transition: height 250ms;\n  box-shadow: 0 1px 1px rgba(16, 22, 26, 0.15);\n}\n\n.mosaic.mosaic-blueprint-theme .mosaic-window-additional-actions-bar .bp3-button,\n.mosaic.mosaic-blueprint-theme .mosaic-window-additional-actions-bar .bp3-button:before {\n  color: #738694;\n}\n\n.mosaic.mosaic-blueprint-theme.additional-controls-open .mosaic-window-toolbar {\n  box-shadow: none;\n}\n\n.mosaic.mosaic-blueprint-theme .mosaic-preview {\n  border: 1px solid #8A9BA8;\n}\n\n.mosaic.mosaic-blueprint-theme .mosaic-preview h4 {\n  color: #394B59;\n}\n\n.mosaic.mosaic-blueprint-theme.bp3-dark {\n  background: #202B33;\n}\n\n.mosaic.mosaic-blueprint-theme.bp3-dark .mosaic-zero-state {\n  background: #30404D;\n  box-shadow: none;\n}\n\n.mosaic.mosaic-blueprint-theme.bp3-dark .mosaic-split:hover .mosaic-split-line {\n  box-shadow: 0 0 0 1px #137CBD;\n}\n\n.mosaic.mosaic-blueprint-theme.bp3-dark .mosaic-drop-target .drop-target-container .drop-target,\n.mosaic.mosaic-blueprint-theme.bp3-dark.mosaic-drop-target .drop-target-container .drop-target {\n  background: rgba(16, 107, 163, 0.2);\n  border-color: #137CBD;\n}\n\n.mosaic.mosaic-blueprint-theme.bp3-dark .mosaic-window-toolbar,\n.mosaic.mosaic-blueprint-theme.bp3-dark .mosaic-window-additional-actions-bar {\n  background: #30404D;\n  box-shadow: 0 1px 1px rgba(16, 22, 26, 0.4);\n}\n\n.mosaic.mosaic-blueprint-theme.bp3-dark .mosaic-window,\n.mosaic.mosaic-blueprint-theme.bp3-dark .mosaic-preview {\n  box-shadow: none;\n}\n\n.mosaic.mosaic-blueprint-theme.bp3-dark .mosaic-window-toolbar.draggable:hover .mosaic-window-title {\n  color: #FFFFFF;\n}\n\n.mosaic.mosaic-blueprint-theme.bp3-dark .mosaic-window-toolbar.draggable:hover {\n  background: linear-gradient(to bottom, #394B59, #30404D);\n}\n\n.mosaic.mosaic-blueprint-theme.bp3-dark .mosaic-window .mosaic-window-toolbar,\n.mosaic.mosaic-blueprint-theme.bp3-dark .mosaic-preview .mosaic-window-toolbar {\n    box-shadow: 0 1px 1px rgb(0 0 0) !important;\n    border-top-right-radius: 2px;\n    border-top-left-radius: 2px;\n    background: #2f343c !important;\n    z-index: 4;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    flex-shrink: 0;\n    height: 30px;\n}\n\n.mosaic.mosaic-blueprint-theme.bp3-dark .mosaic-window .mosaic-window-title,\n.mosaic.mosaic-blueprint-theme.bp3-dark .mosaic-preview .mosaic-window-title {\n    font-weight: 600;\n    color: #ffffff !important;\n}\n\n.mosaic.mosaic-blueprint-theme.bp3-dark .mosaic-window-title {\n  color: #D8E1E8;\n}\n\n.mosaic.mosaic-blueprint-theme.bp3-dark .mosaic-window-controls .separator {\n  border-color: #5C7080;\n}\n\n.mosaic.mosaic-blueprint-theme.bp3-dark .mosaic-window-controls .bp3-button,\n.mosaic.mosaic-blueprint-theme.bp3-dark .mosaic-window-controls .bp3-button:before {\n  color: #A7B6C2;\n}\n\n.mosaic.mosaic-blueprint-theme.bp3-dark .mosaic-window-body {\n  background: #293742;\n}\n\n.mosaic.mosaic-blueprint-theme.bp3-dark .mosaic-window-additional-actions-bar .bp3-button,\n.mosaic.mosaic-blueprint-theme.bp3-dark .mosaic-window-additional-actions-bar .bp3-button:before {\n  color: #BFCCD6;\n}\n\n.mosaic.mosaic-blueprint-theme.bp3-dark.additional-controls-open .mosaic-window-toolbar {\n  box-shadow: none;\n}\n\n.mosaic.mosaic-blueprint-theme.bp3-dark .mosaic-preview {\n  border-color: #5C7080;\n}\n\n.mosaic.mosaic-blueprint-theme.bp3-dark .mosaic-preview h4 {\n  color: #EBF1F5;\n}\n\n.mobile-friendly-navbar {\n    padding: 10px;\n}\n\n.responsive-navbar-group {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 10px;\n}\n\n.responsive-heading {\n    font-size: 18px;\n    white-space: nowrap;\n}\n\n.responsive-divider {\n    display: none;\n}\n\n.navbar-controls {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 10px;\n    align-items: center;\n}\n\n.responsive-select {\n    min-width: 120px;\n}\n\n.responsive-button {\n    white-space: nowrap;\n}\n\n@media (max-width: 768px) {\n    .responsive-heading {\n        font-size: 16px;\n    }\n\n    .responsive-button {\n        padding: 5px 10px;\n        font-size: 12px;\n    }\n}\n\n@media (max-width: 480px) {\n    .responsive-navbar-group {\n        flex-direction: column;\n        align-items: flex-start;\n    }\n\n    .navbar-controls {\n        width: 100%;\n        justify-content: space-between;\n    }\n\n    .responsive-select {\n        width: 100%;\n    }\n\n    .responsive-button {\n        flex: 1;\n        text-align: center;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
